import React from 'react';
import EmbeddedApp from 'components/embedded-app';

// Built marketing app served same-origin by default; `.env.local` can point at its Vite dev server.
// Shared with the artist Strategy page, which loads the same bundle with `?view=strategy`.
export const MARKETING_URL = process.env.REACT_APP_MARKETING_URL || '/marketing-app/index.html';

/** Admin > Marketing. `#deal=<dealId>` (submit/approve mail) opens that plan; no hash is the plan list. */
const MarketingAdmin: React.FC = () => <EmbeddedApp title="Marketing" url={MARKETING_URL} auth />;

export default MarketingAdmin;
